export function initScenicPan() {
    if (document.querySelector('.js-scenic-pan')) {
        import('./scenic_pan.js')
            .then(module => module.default())
            .catch(err => console.error("Errore Scenic Pan:", err));
    }
}
